import { render, staticRenderFns } from "./KufangchukuByIdTable.vue?vue&type=template&id=450067da&"
import script from "./KufangchukuByIdTable.vue?vue&type=script&lang=js&"
export * from "./KufangchukuByIdTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports